import { MDVIP_VERIFY_ACCOUNT_ERROR_PHONE } from '../Constants'

interface ContactMDVIPMessageProps {
  initialMessage: string
  contactMessage?: string
}

export const ContactMDVIPMessage = ({
  initialMessage,
  contactMessage = 'Please contact MDVIP Member Services at',
}: ContactMDVIPMessageProps) => {
  return (
    <p>
      {initialMessage} {contactMessage}{' '}
      <a href={`tel:${MDVIP_VERIFY_ACCOUNT_ERROR_PHONE}`}>{MDVIP_VERIFY_ACCOUNT_ERROR_PHONE}</a>.
    </p>
  )
}
